import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const Search = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            handleName: PropTypes.func,
            value: PropTypes.string,
        };
        state = {
            text: '',
        };
        componentDidMount() {
            if (this.props.value !== 'undefined') {
                this.setState({
                    text: this.props.value,
                });
            }
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps !== this.state.text) {
                this.setState({
                    text: decodeURIComponent(nextProps.value),
                });
            }
            // this.setState({
            //     text: this.props.value,
            // });
        }

        // static getDerivedStateFromProps(p, s) {
        //     if (p.value !== s.text) {
        //         return { text: decodeURIComponent(p.value) };
        //     } else {
        //         return null;
        //     }
        // }

        handleTextChange = text => {
            this.setState({
                text,
            });
            this.props.handleName(text);
        };
        handleButtonSearch = () => {
            this.props.handleName(this.state.text);
        };
        handleInputChange = e => {
            // console.log('name searc==', e);
            this.setState({
                text: e.target.value,
            });
        };
        render() {
            const { text } = this.state;

            return (
                <div className={styles.zp_head}>
                    <div className={styles.col_w1000}>
                        <div className={`${styles.zp_logo} ${styles.mt44}`}>
                            {' '}
                            <a href="http://www.ifeng.com">
                                <img src="//p0.ifengimg.com/fe/fh_recruit/images/logo_07b3b3f3.png" alt="" />{' '}
                            </a>
                        </div>
                        <div className={styles.zp_search}>
                            <input
                                name="搜索"
                                id="btnSh"
                                type="button"
                                className={styles.btnSh}
                                onClick={this.handleButtonSearch}
                            />
                            <input
                                value={text}
                                name=""
                                className={styles.txtKw}
                                type="text"
                                placeholder="请输入职位名称关键字"
                                style={{ color: 'rgb(206, 206, 206)' }}
                                onChange={this.handleInputChange}
                            />
                            <div className={styles.key_word}>
                                <a href="javascript:void(0);" onClick={() => this.handleTextChange('销售')}>
                                    销售
                                </a>&nbsp;&nbsp;
                                <a href="javascript:void(0);" onClick={() => this.handleTextChange('产品')}>
                                    产品
                                </a>&nbsp;&nbsp;
                                <a href="javascript:void(0);" onClick={() => this.handleTextChange('技术')}>
                                    技术
                                </a>&nbsp;&nbsp;
                                <a href="javascript:void(0);" onClick={() => this.handleTextChange('行政')}>
                                    行政
                                </a>&nbsp;&nbsp;
                                <a href="javascript:void(0);" onClick={() => this.handleTextChange('前台')}>
                                    前台
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export { Search };
export default Search;
